

$( window ).on("load", function() { 
	function getCookie(name) {
		let cookie = {};
		document.cookie.split(';').forEach(function(el) {
		  let [k,v] = el.split('=');
		  cookie[k.trim()] = v;
		})
		return cookie[name];
	  }
	  
	  var fbp = getCookie('_fbp');
	  var fbl = getCookie('fbl');
	  var fbc = getCookie('_fbc');
	  var shopgclid = getCookie('gclid');
	
	  if (getCookie('_uetmsclkid').startsWith('_uet')){
		var msclkid = getCookie('_uetmsclkid').slice(4);
	  } else {
		var msclkid = getCookie('_uetmsclkid');
	  };
	
	  var utm_array = [fbp, fbl, fbc, shopgclid, msclkid ];
	  utm_array.forEach((data) => {
		if (i != undefined ){
		  document.getElementById(`${data}`).value = data;
		  console.log(data);
		}
	  });
	
	  document.getElementById("fbp").value = fbp;
	  document.getElementById("fbl").value = fbl;
	  document.getElementById("fbc").value = fbc;
	  document.getElementById("shopgclid").value = shopgclid;
	  document.getElementById("msclkid").value = msclkid;
	  document.getElementById("Form_Url").value = window.location.href;
	
		var attributes = {
		  'fbp': fbp,
		  'fbl': fbl,
		  'fbc': fbc,
		  'shopgclid': shopgclid,
		  'msclkid': msclkid
		  }
	
		for (var key in attributes){
		  if(attributes[key] == undefined || attributes[key] == null) {
			delete attributes[key]
		  }
		}
	  
		$.post('/cart.js', {
		attributes
		}).done(function () {
		  console.log(attributes)
		});
		
	
	  });
	// });
	
	
	
	
	
	